import { useEffect, useState } from "react";
import axios from "axios";
import { Hammer } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Choix des métiers de l'artisan à l'inscription (liste servie par /artisans/specialties)
export const ArtisanSpecialtyPicker = ({ value, onChange }) => {
  const [specialties, setSpecialties] = useState([]);

  useEffect(() => {
    axios.get(`${API}/artisans/specialties`).then((r) => setSpecialties(r.data || [])).catch(() => {});
  }, []);

  const toggle = (key) => onChange(value.includes(key) ? value.filter((k) => k !== key) : [...value, key]);

  return (
    <div className="p-4 bg-[#0F172A] rounded-2xl border border-orange-400/30 space-y-3" data-testid="register-artisan-specialties">
      <h4 className="font-bold uppercase tracking-widest text-xs text-orange-400 flex items-center gap-2">
        <Hammer className="w-4 h-4" /> Vos métiers *
      </h4>
      <div className="flex flex-wrap gap-2">
        {specialties.map((s) => {
          const active = value.includes(s.key);
          return (
            <button
              key={s.key}
              type="button"
              onClick={() => toggle(s.key)}
              className={`px-3 py-1.5 rounded-full text-xs font-bold transition-colors ${active ? "bg-[#D4AF37] text-[#0F172A]" : "bg-white/10 text-white/70 hover:bg-white/20"}`}
              data-testid={`register-spec-${s.key}`}
            >
              <span className="mr-1">{s.icon}</span>{s.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
